module.exports = __webpack_public_path__ + "media/images/adform_small_logo-8dd3a535367aa05eebe65b9ac76a4fa2.png";